import { BrowserRouter } from 'react-router-dom';
import { AppToaster } from '@/components/ui/AppToaster';
import { AdminAuthProvider } from '@/context/AdminAuthContext';
import { UserAuthProvider } from '@/context/UserAuthContext';
import { AppRoutes } from '@/routes/AppRoutes';

export default function App() {
  return (
    <UserAuthProvider>
      <AdminAuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <AppToaster />
      </AdminAuthProvider>
    </UserAuthProvider>
  );
}
